import gsap from 'gsap';

class InnerLoader {
	constructor(container, { style = 'dark', init = true, opacity = 0.9 } = {}) {
		this.container = container;
		this.loader;
		this.style = style;
		this.init = init;
		this.opacity = opacity
		this.svg = `<svg><rect x="0px" y="0px" /></svg>`;
		this.icon = false;
		this.isOpen = false;

		//if(this.init) this.create()
	}
	create() {
		this.loader = document.createElement('div');
		this.loader.classList.add('franclizer--inner-loader');

		if(this.style == 'dark') this.loader.classList.add('dark--loader');
		if(this.style == 'light') this.loader.classList.add('light--loader');

		let bg = document.createElement('div');
		let icon = document.createElement('div');
		bg.classList.add('loader--bg')
		icon.classList.add('loader--icon')
		icon.innerHTML = this.svg;
		this.loader.appendChild(bg)
		this.loader.appendChild(icon)

		this.container.appendChild(this.loader)
	}
	open(loader = true){
		//this.icon = loader;
		return new Promise((resolve,reject) => {
			gsap.to(this.container, { duration: 0.25, autoAlpha: 1, onComplete: () => {
				this.isOpen = true;
				resolve()
			}})
			/* gsap.to(this.loader.querySelector('.loader--bg'), { duration: .25, autoAlpha: this.opacity, onComplete: () => {
				this.isOpen = true;
				resolve()
			}})
			if(loader) {
				gsap.to(this.loader.querySelector('.loader--icon'), { duration: .25, autoAlpha: 1 }) 
			} */
		})
	}
	close(){
		return new Promise((resolve,reject) => {
			/* gsap.to(this.loader.querySelector('.loader--bg'), { duration: .25, autoAlpha: 0 })
			gsap.to(this.loader.querySelector('.loader--icon'), { duration: .25, autoAlpha: 0 }) */
			gsap.to(this.container, { duration: 0.25, autoAlpha: 0, onComplete: () => {
				this.isOpen = false;
				resolve()
			}})
		})
	}
	switch(){
		if(this.icon){
			this.icon = false;
			gsap.to(this.loader.querySelector('.loader--icon'), { duration: .25, autoAlpha: 0, ease: 'power4.inOut' })
		}else{
			this.icon = true;
			gsap.to(this.loader.querySelector('.loader--icon'), { duration: .25, autoAlpha: 1, ease: 'power4.inOut' })
		}
	}
}

class FullLoader {
	constructor(){
		this.loader = document.querySelector('.full--loader')
		this.isLoaderAnimating = false;
		this.isLoaderOpen = false;
		this.icon = false;

		this.loader.classList.add('dark--loader');
	}
	open(icon = true){
		this.icon = icon;
		this.isLoaderAnimating = true;
		return new Promise((resolve,reject) => {
			gsap.to(this.loader, { duration: 0, autoAlpha: 1 })
			if(this.icon) {
				gsap.to(this.loader.querySelector('.loader--icon'), { duration: 0, autoAlpha: 1 })
			}else{
				gsap.to(this.loader.querySelector('.loader--icon'), { duration: 0, autoAlpha: 0 })
			}
			gsap.to(this.loader.querySelector('.loader--bg'), { duration: .5, autoAlpha: 1, ease: 'power4.inOut', onComplete: () => {
				this.isLoaderOpen = true;
				this.isLoaderAnimating = false;
				resolve()
			}})
		})
	}
	close(){
		this.isLoaderAnimating = true;

		return new Promise((resolve,reject) => {
			if(this.icon) {
				gsap.to(this.loader.querySelector('.loader--icon'), { duration: .3, autoAlpha: 0 })

				this.icon = false;
			}
			gsap.to(this.loader.querySelector('.loader--bg'), { duration: .5, autoAlpha: 0, ease: 'power4.inOut' })
			gsap.to(this.loader, { duration: 0, delay: .5, autoAlpha: 0, onComplete: () => {
				this.isLoaderOpen = false;
				this.isLoaderAnimating = false;
				resolve()
			}})
		})
	}
	switch(){
		if(this.icon){
			this.icon = false;
			gsap.to(this.loader.querySelector('.loader--icon'), { duration: .5, autoAlpha: 0, ease: 'power4.inOut' })
		}else{
			this.icon = true;
			gsap.to(this.loader.querySelector('.loader--icon'), { duration: .5, autoAlpha: 1, ease: 'power4.inOut' })
		}
	}
	removeIcon(){
		if(this.icon) {
			this.icon = false;
			gsap.to(this.loader.querySelector('.loader--icon'), { duration: 0, autoAlpha: 0 })
		}
	}
	changeZIndex(action){
		if(action == 'bringToFront'){
			this.loader.style.zIndex = 700;
		}else if(action == 'sendToBack'){
			this.loader.style.zIndex = 500;
		}
	}
}

export { InnerLoader, FullLoader }